import React, { useState } from 'react';
import { BsSearch } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import GlassPanel from '../common/GlassPanel';

const SearchBar = ({ onSearch }) => {
  const [city, setCity] = useState('');

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearch(city);
    }
  };

  return (
    <GlassPanel className="SearchBar animate-fade">
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <FaLocationDot style={{ color: 'var(--accent-blue)', fontSize: '1.2rem' }} />
        
        <input
          type="text"
          placeholder="Buscar ciudad..."
          value={city}
          onChange={(e) => setCity(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <button 
          onClick={() => onSearch(city)}
          style={{
            background: 'var(--accent-blue)',
            color: 'var(--white)',
            borderRadius: '12px',
            width: '45px',
            height: '45px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '1.1rem',
            boxShadow: '0 4px 15px hsla(210, 100%, 50%, 0.3)'
          }}
        >
          <BsSearch />
        </button>
      </div>
    </GlassPanel>
  );
};

export default SearchBar;
